export enum InvoiceStatus {
  sent = 'sent',
  draft = 'draft',
  saved = 'saved',
  paid = 'paid',
  cancelled = 'cancelled'
}
